export default "__VITE_ASSET__DAbrdhSP__"